var _rect, _path, _rect2, _path2, _rect3, _rect4, _path3, _path4, _rect5, _rect6, _rect7, _path5, _rect8, _rect9, _path6, _rect10, _rect11, _path7, _rect12, _circle, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtTestCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 521,
    height: 268,
    viewBox: "0 0 521 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 172.925,
    y: 192.051,
    width: 26.7141,
    height: 5.30963,
    rx: 2.65482,
    transform: "rotate(-32.4157 172.925 192.051)",
    fill: "#52D5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M262.62 213.165C261.233 213.536 259.806 212.713 259.434 211.325L254.005 191.063C253.633 189.675 254.457 188.249 255.845 187.877V187.877C257.233 187.505 258.659 188.329 259.031 189.716L264.46 209.978C264.832 211.366 264.008 212.793 262.62 213.165V213.165Z",
    fill: "#D662FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.72,
    x: 210.215,
    y: 231.537,
    width: 16.0285,
    height: 3.18578,
    rx: 1.59289,
    transform: "rotate(137 210.215 231.537)",
    fill: "#FF5E98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M341.068 235.674C342.001 234.741 343.514 234.741 344.447 235.674L358.069 249.296C359.002 250.229 359.002 251.742 358.069 252.675V252.675C357.136 253.608 355.623 253.608 354.69 252.675L341.068 239.053C340.135 238.12 340.135 236.607 341.068 235.674V235.674Z",
    fill: "#D662FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.81,
    x: 489.428,
    y: 180.24,
    width: 30.7212,
    height: 6.10608,
    rx: 3.05304,
    transform: "rotate(24.51 489.428 180.24)",
    fill: "#FF5E98"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158.572,
    y: 73.5898,
    width: 26.1798,
    height: 5.20344,
    rx: 2.60172,
    transform: "rotate(14.2604 158.572 73.5898)",
    fill: "#52D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M214.078 147.644C213.212 150.022 210.583 151.248 208.204 150.383L173.485 137.746C171.107 136.88 169.88 134.251 170.746 131.872V131.872C171.612 129.494 174.241 128.268 176.62 129.133L211.339 141.77C213.717 142.636 214.944 145.266 214.078 147.644V147.644Z",
    fill: "#D662FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M303.461 86.7815C300.816 85.707 299.542 82.6913 300.616 80.0458L316.303 41.4253C317.377 38.7797 320.393 37.5062 323.038 38.5807V38.5807C325.684 39.6552 326.957 42.6709 325.883 45.3164L310.197 83.9369C309.122 86.5824 306.107 87.856 303.461 86.7815V86.7815Z",
    fill: "#D662FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.99,
    x: 77.2695,
    y: 11.999,
    width: 31.4987,
    height: 6.26061,
    rx: 3.13031,
    transform: "rotate(43 77.2695 11.999)",
    fill: "#FFCE47"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.89,
    x: 234.559,
    y: 147.792,
    width: 46.4322,
    height: 9.22876,
    rx: 4.61438,
    transform: "rotate(70 234.559 147.792)",
    fill: "#52D5FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 492.567,
    y: 260.751,
    width: 41.7145,
    height: 8.29108,
    rx: 4.14554,
    transform: "rotate(-167.127 492.567 260.751)",
    fill: "#FFCE47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M3.52245 60.598C1.60187 60.6987 0.126518 62.3372 0.227171 64.2578L1.69656 92.2954C1.79721 94.216 3.43575 95.6913 5.35634 95.5907V95.5907C7.27692 95.49 8.75227 93.8515 8.65162 91.9309L7.18223 63.8933C7.08158 61.9727 5.44304 60.4974 3.52245 60.598V60.598Z",
    fill: "#D662FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 112.842,
    y: 154.616,
    width: 41.147,
    height: 8.17828,
    rx: 4.08914,
    transform: "rotate(-161 112.842 154.616)",
    fill: "#FF5E98"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.91,
    x: 520.701,
    y: 38.2959,
    width: 59.6749,
    height: 11.8609,
    rx: 5.93043,
    transform: "rotate(136.468 520.701 38.2959)",
    fill: "#52D5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M390.192 2.7429C390.298 1.22804 391.612 0.0858727 393.127 0.191802L415.241 1.73821C416.756 1.84413 417.898 3.15804 417.792 4.6729V4.6729C417.686 6.18776 416.373 7.32992 414.858 7.224L392.743 5.67759C391.228 5.57166 390.086 4.25775 390.192 2.7429V2.7429Z",
    fill: "#D662FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.84,
    x: 21,
    y: 261.316,
    width: 61.1884,
    height: 12.1617,
    rx: 6.08083,
    transform: "rotate(-57 21 261.316)",
    fill: "#FF5E98"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 106.414,
    y: 256.142,
    width: 44.3653,
    height: 8.81795,
    rx: 4.40897,
    transform: "rotate(-31.4707 106.414 256.142)",
    fill: "#FFCE47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M382.004 188.829C380.53 191.017 381.11 193.985 383.298 195.459L415.243 216.968C417.431 218.442 420.4 217.862 421.873 215.674V215.674C423.346 213.486 422.767 210.517 420.579 209.044L388.634 187.535C386.446 186.061 383.477 186.641 382.004 188.829V188.829Z",
    fill: "#D662FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 61.6313,
    height: 12.2497,
    rx: 6.12485,
    transform: "matrix(0.740397 -0.672169 -0.672169 -0.740397 377.06 122.897)",
    fill: "#FF5E98"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 268.532,
    cy: 171.447,
    r: 79.9169,
    fill: "url(#paint0_radial_5601_3336)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.818 186.245L239.591 169.986L234.182 175.405L255.818 197.085L302.181 150.629L296.772 145.209L255.818 186.245Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5601_3336",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.532 171.447) rotate(90) scale(79.9169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#5EF993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#FFCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#FF5E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#97E6FF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF7FF",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtTestCompleted);
export default __webpack_public_path__ + "static/media/ext_test_completed.74be24796fcc3ac2d257e046547e2b20.svg";
export { ForwardRef as ReactComponent };